<template>
  <div class="post-page">
    <loader v-if="!post" class="centered"></loader>
    <div v-else>
      <div class="post-content brick">
        <div class="additional">
          <post-delete-button
            v-if="isAdmin"
            :postId="postId"
          ></post-delete-button>

          <post-edit-button
            v-if="isAdmin"
            :postId="postId"
          ></post-edit-button>

          <post-info :post="post"></post-info>

          <post-share
            v-if="isMember"
            :post="post"
          ></post-share>
        </div>

        <div v-if="!disableEasyNavigation" class="special-link-wrapper back-nav-button">
          <router-link :to="{ name: 'home' }" class="special-link" @click.native="trackEasyNavigation">
            <v-icon x-large>keyboard_backspace</v-icon>
          </router-link>
        </div>
        <h1>{{ post.title }}</h1>

        <vue-markdown v-if="post.description">{{ post.description }}</vue-markdown>

        <loader v-if="!media" class="centered"></loader>
        <!-- <media-gallery
          v-else
          :media="media"
          class="media-gallery"
        ></media-gallery> -->
        <media-item
          v-for="item, index in media"
          :key="item.id"
          :item="item"
        ></media-item>

      </div>

      <div class="comments" v-if="isMember">
        <comments
          :postId="postId"
          :auth="auth"
          :subscribed="subscribed"
          @subscribe="subscribe"
          @unsubscribe="unsubscribe"
          class="brick"
        ></comments>
      </div>

    </div>
  </div>
</template>

<script>
import deepCopy from 'deep-copy';

import VueMarkdown from 'vue-markdown';
import MediaGallery from '@/components/MediaGallery';
import MediaItem from '@/components/MediaItem';
import Loader from '@/components/Loader';
import Comments from '@/components/Comments/Comments';
import PostInfo from '@/components/PostInfo';
import PostShare from '@/components/PostShare';
import PostEditButton from '@/components/PostEditButton';
import PostDeleteButton from '@/components/PostDeleteButton';

import { loadPost } from '@/store/actionTypes';

import { getPostMedia } from '@/firebase/repositories/media';

import { isSubscribed, unsubscribe, subscribe } from '@/firebase/repositories/subscriptions';

export default {
  name: 'post-page',
  components: {
    MediaGallery,
    MediaItem,
    Loader,
    VueMarkdown,
    Comments,
    PostInfo,
    PostShare,
    PostEditButton,
    PostDeleteButton,
  },
  data() {
    return {
      media: null,
      subscribed: null,
    };
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    isMember() {
      return this.$store.getters.isMember;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    disableEasyNavigation() {
      return this.$store.getters.disableEasyNavigation;
    },
    post() {
      const { alias, publicKey } = this.$route.params;
      const cacheKey = publicKey ? `${alias}-${publicKey}` : alias;

      return this.$store.getters.cachedPosts[cacheKey];
    },
    postId() {
      return this.post && this.post.id;
    },
  },
  watch: {
    postId: {
      handler() {
        this.loadPostMedia();
        this.checkSubscription();
      },
      immediate: true,
    },
  },
  mounted() {
    this.loadPost();
  },
  methods: {
    loadPost() {
      const { alias, publicKey } = this.$route.params;

      this.$store.dispatch(loadPost, { alias, publicKey }).catch(() => {
        this.$router.push({ name: 'notFound' });
      });
    },
    loadPostMedia() {
      if (this.postId) {
        getPostMedia(this.postId).then((media) => {
          this.media = this.groupVideos(media);
        });
      }
    },
    checkSubscription() {
      if (this.auth && this.auth.uid && this.postId) {
        isSubscribed(this.auth.uid, this.postId).then((subscribed) => {
          this.subscribed = subscribed;
        });
      }
    },
    subscribe() {
      this.subscribed = null;
      subscribe(this.auth.uid, this.postId).then(
        () => {
          this.subscribed = true;
          this.$ga.event('post-notifications', 'enabled', location.pathname);
        },
        () => {
          this.subscribed = false;
        },
      );
    },
    unsubscribe() {
      this.subscribed = null;
      unsubscribe(this.auth.uid, this.postId).then(
        () => {
          this.subscribed = false;
          this.$ga.event('post-notifications', 'disabled', location.pathname);
        },
        () => {
          this.subscribed = true;
        },
      );
    },
    trackEasyNavigation() {
      this.$ga.event('easy-navigation', 'clicked', '←');
    },
    groupVideos(mediaItems) {
      const videoNamesMap = {};
      const items = [...mediaItems];
      mediaItems.forEach((item, index) => {
        if (item.type === 'video') {
          const refPrefix = `${this.post.storagePrefix}-${item.storagePrefix}-`;
          const ref = item.video && item.video.ref;
          const originalFilename = (ref || '').split(refPrefix).pop();
          const filenameWOExtension = originalFilename.split('.').slice(0, -1).join('.');

          const originalIndex = videoNamesMap[filenameWOExtension];
          if (originalIndex === undefined) {
            videoNamesMap[filenameWOExtension] = index;
          } else {
            items[originalIndex] = deepCopy(items[originalIndex]);
            items[originalIndex].additionalSources = items[originalIndex].additionalSources || [];
            items[originalIndex].additionalSources.push(deepCopy(item));
            items[originalIndex].poster = items[originalIndex].poster || item.poster;

            items[index] = null;
          }
        }
      });

      return items.filter(Boolean);
    },
  },
};
</script>

<style scoped>
h1 {
  text-align: left;
}

/*.post-page {
  max-width: 920px;
  margin: 0 auto;
  padding: 0 20px;
}*/

.additional {
  float: right;
  margin-top: 4px;
}

.media-gallery {
  margin-top: 20px;
}

.media-item {
  margin: 30px 0;
}

.comments {
  background: #eee;
}

.special-link {
  text-decoration: none;
}
</style>

<style>
.post-page .additional .btn {
  margin-right: 0;
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/containers/PostPage.vue